import React, { forwardRef } from "react";
import {
  TextField,
  Box,
  Typography,
  OutlinedInput,
  InputAdornment,
  FormControl,
  InputLabel,
} from "@mui/material";
import { IMaskInput } from "react-imask";

const TimeMaskCustom = forwardRef(function TimeMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="00"
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

export default function TimeInput({ time, setTime }) {
  const handleChange = (event) => {
    setTime({
      ...time,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <FormControl variant="outlined">
      <InputLabel htmlFor="time-input">공정 시간</InputLabel>
      <OutlinedInput
        id="time-input"
        label="Time"
        value=""
        readOnly
        fullWidth
        inputProps={{ tabIndex: -1 }}
        startAdornment={
          <InputAdornment fullWidth position="start">
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <TextField
                value={time.hours}
                onChange={handleChange}
                name="hours"
                placeholder="시"
                InputProps={{
                  inputComponent: TimeMaskCustom,
                }}
                inputProps={{
                  tabIndex: 1,
                  min: 0,
                  max: 23,
                  style: { caretColor: "transparent" },
                }}
                sx={{
                  width: "30%",
                  "& input": {
                    textAlign: "center",
                    "&::placeholder": {
                      textAlign: "center",
                    },
                  },
                }}
                variant="standard"
              />
              <Typography variant="h6" sx={{ mx: 0.5 }}>
                :
              </Typography>
              <TextField
                value={time.minutes}
                onChange={handleChange}
                name="minutes"
                placeholder="분"
                InputProps={{
                  inputComponent: TimeMaskCustom,
                }}
                inputProps={{
                  tabIndex: 2,
                  min: 0,
                  max: 59,
                  style: { caretColor: "transparent" },
                }}
                sx={{
                  width: "30%",
                  "& input": {
                    textAlign: "center",
                    "&::placeholder": {
                      textAlign: "center",
                    },
                  },
                }}
                variant="standard"
              />
              <Typography variant="h6" sx={{ mx: 0.5 }}>
                :
              </Typography>
              <TextField
                value={time.seconds}
                onChange={handleChange}
                name="seconds"
                placeholder="초"
                InputProps={{
                  inputComponent: TimeMaskCustom,
                }}
                inputProps={{
                  tabIndex: 3,
                  min: 0,
                  max: 59,
                  style: { caretColor: "transparent" },
                }}
                sx={{
                  width: "30%",
                  "& input": {
                    textAlign: "center",
                    "&::placeholder": {
                      textAlign: "center",
                    },
                  },
                }}
                variant="standard"
              />
            </Box>
          </InputAdornment>
        }
        endAdornment={<InputAdornment position="end" />}
      />
    </FormControl>
  );
}
